import { Link } from "react-router-dom";
import FormatPrice from "./FormatPrice";
import { useState } from "react";

const SingleProduct = ({ index, item, addToCart, addToOrder }) => {
  const [amount, setamount] = useState(1);

  const setDecrease = () => {
    amount > 1 ? setamount(amount - 1) : setamount(1);
  };

  const setIncrease = () => {
    amount < item.initial_stock
      ? setamount(amount + 1)
      : setamount(item.initial_stock);
  };

  return (
    <div className="pro" key={index}>
      <Link to={`/productdetails/${item.id}`}>
        <img src={item.image} alt="" />
      </Link>

      <div className="des" style={{ padding: "0px", marginTop: "5px" }}>
        <Link
          to={`/productdetails/${item.id}`}
          style={{ textDecoration: "none", color: "black" }}
        >
          <h6>
            <b>{item.name}</b>
          </h6>
        </Link>
      </div>

      <div className="des" style={{ padding: "0px" }}>
        <span>
          Price:{" "}
          <del>
            <b>
              <FormatPrice price={item.selling_price} />
            </b>
          </del>
        </span>
      </div>

      <div className="des" style={{ padding: "0px", marginBottom: "10px" }}>
        <span>
          Discount Price:{" "}
          <b>
            <FormatPrice price={item.selling_price - item.discount} />
          </b>
        </span>
      </div>

      {item.initial_stock < 1 ? (
        <div className="detailsPtag_Btn my-3 mx-2">
          {/* <button onClick={() => setDecrease()}></button> */}
          <p
            style={{ fontSize: "8px", fontWeight: "700", color: "red" }}
            className="detailsPtagCount mb-3 mx-0"
          >
            Out of stock
          </p>
          {/* <button onClick={() => setIncrease()}></button> */}
        </div>
      ) : (
        <div className="detailsPtag_Btn my-3 mx-2">
          <button onClick={() => setDecrease()}>-</button>
          <p className="detailsPtagCount">{amount}</p>
          <button onClick={() => setIncrease()}>+</button>
        </div>
      )}

      <div
        className="d-flex align-items-center"
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "space-between",
        }}
      >
        <Link to={`/productdetails/${item.id}/`}>
          <button className="normalll">View Details</button>
        </Link>

        <Link
          to="/order-checkout"
          onClick={() => {
            addToOrder(item.id, amount, item);
            setamount(1);
          }}
          className={`${item.initial_stock < 1 ? "disabled" : ""}`}
        >
          <button className="normalll">Order Now</button>
        </Link>
      </div>

      {/* <Link>
        <i
          style={{
            fontSize: "2rem",
            width: "50px",
            height: "50px",
            color: "black",
          }}
          className="fa-regular fa-heart"
        ></i>
      </Link> */}

      <Link
        onClick={() => {
          addToCart(item.id, amount, item);
          setamount(1);
        }}
        className={`${item.initial_stock < 1 ? "disabled" : ""}`}
      >
        <i
          style={{ color: "black" }}
          className="cart fa-solid fa-shopping-cart"
        ></i>
      </Link>
    </div>
  );
};

export default SingleProduct;
